module.exports = __webpack_public_path__ + "static/Sonyax5f-f4f071d32121a707e211ad95ea03964d.png";